import type { AiChatbotCmsPrompt } from "../../../../features/ai-chatbot/types/ai-chatbot-cms-prompt.entity";
import type { IAiPromptManager } from "./ai-prompt-manager.interface";

export class AiChatbotPromptManager implements IAiPromptManager {
  public getPrompt(prompt: AiChatbotCmsPrompt): string {
    const message = prompt.aiPromptInput.promptMessage;

    return message;
  }

  getFallbackResponse(prompt: AiChatbotCmsPrompt): string | undefined {
    return prompt?.defaultErrorResponse;
  }
}
